const TOKEN_REFRESH_BUFFER_MS = 10_000;

/**
 * Determines whether a preemptive token refresh is needed before sending a tRPC request.
 *
 * @param path - The tRPC operation path (e.g. "user.me", "auth.accessToken")
 * @param tokenExpiresAt - Epoch ms when the current access token expires, or null if unauthenticated
 * @param now - Current time in epoch ms (injectable for testing, defaults to Date.now())
 * @returns true if a refresh should be triggered before the request
 */
export function isTokenRefreshNeeded(
  path: string,
  tokenExpiresAt: number | null,
  now: number = Date.now(),
): boolean {
  // Never intercept auth routes to avoid infinite refresh loops
  if (path.startsWith('auth.')) {
    return false;
  }

  // No token metadata — user is unauthenticated, let the request pass through
  if (tokenExpiresAt === null) {
    return false;
  }

  // Token expires within the buffer window — trigger preemptive refresh
  return tokenExpiresAt <= now + TOKEN_REFRESH_BUFFER_MS;
}
